import { lazy } from "react";

import { extendRoutes } from "./utils";

const Tenx = lazy(() => import("../Games/Tenx/Tenx"));
const Memory = lazy(() => import("../Games/Memory/Memory"));
const Unnamed = lazy(() => import("../Games/Unnamed/Unnamed"));
const TicTacToe = lazy(() => import("../Games/TicTacToe/TicTacToe"));
const GamesBacklog = lazy(() => import("../Games/Backlog"));
const Hangman = lazy(() => import("../Games/Hangman/Hangman"));
const TenxTestimonials = lazy(() => import("../Games/Tenx/Testimonials"));
const RockPaperScissors = lazy(
  () => import("../Games/RockPaperScissors/RockPaperScissors")
);
const Guessing = lazy(() => import("../Games/Guessing/Guessing"));

export const gameRoutes = extendRoutes([
  {
    path: "",
    title: "Games",
    component: null,
  },
  {
    path: "backlog",
    title: "Games backlog",
    component: <GamesBacklog />,
  },
  {
    path: "10x",
    title: "10x",
    component: <Tenx />,
  },
  {
    path: "10x/testimonials",
    title: "10x Testimonials",
    component: <TenxTestimonials />,
  },
  {
    path: "memory",
    title: "Memory",
    component: <Memory />,
  },
  {
    path: "unnamed",
    title: "Unnamed",
    component: <Unnamed />,
  },
  {
    path: "tictactoe",
    title: "Tic Tac Toe",
    component: <TicTacToe />,
  },
  {
    path: "hangman",
    title: "Hangman",
    component: <Hangman />,
  },
  { path: "guessing", title: "Guessing", component: <Guessing /> },
  {
    path: "rock-paper-scissors",
    title: "RockPaperScissors",
    component: <RockPaperScissors />,
  },
]);

export default gameRoutes;
